import { Accordion } from '@descomplica/foundation-ui-components';
import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 0 45px;
  }

  @media (min-width: 1024px) {
    padding: 0 95px;
  }

  @media (min-width: 1280px) {
    padding: unset;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: 16px;
`;

export const ThemeInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

export const BodyEssayContainer = styled.div`
  display: grid;
  grid-template-columns: 7fr 3fr;
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: 7fr 3fr;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const StatusTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #636769;
  padding: 24px 24px 24px 24px;
`;

export const SidebarContainer = styled.div`
  @media (max-width: 1024px) {
    order: -1;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    order: -1;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  input {
    margin-bottom: 16px;
    background-color: transparent;
    border: 1px solid #96999c;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 24px;
  }

  textarea {
    height: 100%;
    background-color: transparent;
    border: 1px solid #96999c;
    padding: 12px 16px;
    border-radius: 8px;

    &::placeholder {
      color: #fff;
      opacity: 100%;
    }
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 52px;
  letter-spacing: -1.8px;
  text-align: left;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 52px;
    margin-top: 16px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 1;
  }
`;

export const Breadcrumb = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: #caccce;
  cursor: pointer;
`;

export const StatusInfo = styled.span`
  font-family: Aprova Nova;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -1px;
`;

export const ChangeThemeButton = styled.button`
  font-size: 16px;
  position: relative;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: var(--color-primary-gray-05, #ddd);
  text-decoration: underline;
  cursor: pointer;
`;

export const StatusTag = styled.span`
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.4px;
  text-align: left;
  color: #636769;
`;

export const EssayBodyTag = styled.span`
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.4px;
  text-align: left;
  text-transform: uppercase;
  color: #636769;
`;

export const EssayInstructionsContainer = styled.div`
  border: 1px solid #636769;
  border-radius: 8px;
`;

export const EssayInstructionsContainerSection = styled.div`
  border-bottom: 1px solid #636769;
  padding: 24px 24px 0 24px;

  path {
    fill: #fff;
  }
`;

export const EssayInstructions = styled.div`
  font-family: Aprova Nova;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  text-align: left;
  margin-bottom: 8px;
  margin-right: 8px;
`;

export const EssayInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  text-align: justify;
  white-space: pre-line;

  p {
    margin-top: 0px;
    margin-bottom: 15px;
    font-family: Aprova Nova;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
`;

export const HighlightEssayButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    justify-content: center;
    align-items: space-between;

    button {
      margin-top: 8px;
      width: 100%;
      margin-left: 0;
    }
  }
`;

export const DetailsButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 20px 12px 24px;
  background-color: #f2f2f3;
  border-radius: 300px;
  color: #636769;
  margin-left: 16px;

  span {
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    margin-left: 8px;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  path {
    fill: black;
    max-width: 14px;
    max-height: 14px;
  }

  @media (max-width: 360px) {
    margin-right: unset;
  }
`;

export const BoxEssayInfo = styled.div`
  background: #191a1a80;
  opacity: 0.75;
  border-radius: 8px;
  padding: 16px;
`;

export const BoxEssayInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 6px 1px;

  &:nth-child(2) {
    border-bottom: 1px solid #e5e6e7;
    border-top: 1px solid #e5e6e7;
    padding: 10px 1px;
  }

  span {
    font-family: Aprova Nova;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    min-height: 16px;
    height: auto;
    letter-spacing: -0.4000000059604645px;
    text-align: right;
  }
`;

export const BoxEssayCompetenceItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 6px 1px;

  &:nth-child(2) {
    border-bottom: 1px solid #e5e6e7;
    border-top: 1px solid #e5e6e7;
    padding: 10px 1px;
  }

  &:nth-child(3) {
    border-bottom: 1px solid #e5e6e7;
    padding: 10px 1px;
  }
  &:nth-child(4) {
    border-bottom: 1px solid #e5e6e7;
    padding: 10px 1px;
  }

  span {
    font-family: Aprova Nova;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    min-height: 16px;
    height: auto;
    letter-spacing: -0.4000000059604645px;
    text-align: right;
  }
`;

export const ScoreLabel = styled.p`
  font-size: 18px;
  line-height: 19px;
`;

export const Score = styled.p`
  font-size: 80px;
  line-height: 1;
  font-weight: 700;

  span {
    display: inline-block;
    font-size: 16px;
    font-weight: normal;
    transform: translateY(-5px);
  }
`;

export const OverallComment = styled.p`
  h2 {
    margin-top: 24px;
    margin-bottom: 12px;
    font-family: Aprova Nova;
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: -1px;
    text-align: left;
  }
`;

export const TitleCompetenceComment = styled.h2`
  font-family: Aprova Nova;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;
  color: #fff;
  margin: 6px 0;
`;

export const BoxEssayCompetenceInfo = styled.div`
  background: #191a1a80;
  opacity: 0.75;
  border-radius: 8px;
  padding: 16px;
  min-height: 56px;
  margin: 6px 0;
`;

export const BoxEssayCompetenceInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 6px 1px;
  gap: 2;
`;

export const CompetenceInfoBody = styled.div`
  font-family: Aprova Nova;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
`;

export const CompetenceInfoScore = styled.div`
  font-family: Aprova Nova;
  font-size: 48px;
  font-weight: 800;
  line-height: 48px;
  text-align: left;
`;

export const CompetenceTitle = styled.h1`
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #f2f2f3;
  padding-bottom: 8px;
`;

export const ItemAccordion = styled(Accordion.Item)`
  border-bottom: 1px solid #636769;
`;

export const CompetenceBoxTitle = styled.h2`
  font-family: Aprova Nova;
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;

  min-height: 36px;
  height: auto;
  padding-bottom: 20px;
  border-bottom: 1px solid #636769;
  margin-bottom: 16px;
`;
